import React from "react";

export interface Info {
    title: string;
    value: any;
}

interface SectionProps {
    title: string;
    infoList: Info[];
}

const Section = ({ title, infoList }: SectionProps) => {
    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <div className="tw-text-lg tw-font-semibold tw-text-gray-800">{title}</div>
            <div className="tw-flex tw-flex-col">
                {infoList.map((info: Info, idx: number) => {
                    const hasValue = !(info.value === undefined || info.value === null || info.value === "");
                    return (
                        <div
                            key={`info-${idx}-${info.title}`}
                            className="tw-grid tw-grid-cols-3 md:tw-grid-cols-4 tw-items-baseline tw-gap-x-3 tw-py-1"
                        >
                            <div className="tw-col-span-1 tw-text-md tw-text-gray-500">{info.title}</div>
                            <div className={[
                                "tw-col-span-2 md:tw-col-span-3 tw-text-md tw-font-medium tw-leading-6 tw-truncate",
                                hasValue ? "tw-text-gray-900" : "tw-text-gray-400 tw-italic",
                            ].join(" ")}>
                                {hasValue ? info.value : "—"}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Section;
